import styled from "styled-components";

export const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: "Roboto", "Helvetica Neue", "monospace";
  font-weight: 600;
  font-size: 1.5rem;
  cursor: pointer;
  margin-left: -4px;
  text-shadow: rgb(50, 50, 50) 0 0 10px;
`;

export const Icon = styled.span`
  margin-left: 10px;
`;

export const City = styled.p`
  font-family: "Roboto", "Helvetica Neue", "monospace";
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: -18px;
`;

export const Temperature = styled.h2`
  font-family: "Roboto", "Helvetica Neue", "monospace";
  text-align: center;
`;

export const Wind = styled.p`
  font-family: "Roboto", "Helvetica Neue", "monospace";
  font-size: 16px;
  font-weight: 400;
  margin-bottom: -10px;
`;

export const WeeklyForecastButton = styled.button`
  color: #f8f8f8;
  font-family: "Fira Mono", monospace;
  font-weight: 700;
  font-size: 1rem;
  background-color: #1b2430;
  border-radius: 8px;
  border: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 4px 8px;
  cursor: pointer;
`;

export const WeeklyForecast = styled.div`
  display: flex;
  min-width: 500px;
  max-width: 1000px;
  border-radius: 5px;
  animation: slideUp 0.5s ease;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

export const WeatherBox = styled.div`
  position: absolute;
  right: 1.5rem;
  top: 0;
  text-align: center;
  color: #fff;
  text-shadow: rgb(50, 50, 50) 0 0 10px;
`;

export const Day = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "Fire Mono", monospace;
  font-size: 14px;
  padding: 20px;
  &:last-child {
    border-right: none;
  }
  text-align: center;
  margin: -10px 0;
`;
